'use client'

import React from 'react'
import { getPaymentMethods, getDeliveryMethods } from '@dustin-web/microsite-config'
import { useSiteContext, useTranslations } from '@dustin-web/microsite-components/src/hooks'
import { FooterDeliveryPayments } from './footer-delivery-payments'

export const FooterDeliveryPaymentsContainer = () => {
  const { site } = useSiteContext()
  const paymentMethods = getPaymentMethods(site)
  const deliveryMethods = getDeliveryMethods(site)
  const { translate } = useTranslations()
  return (
    <FooterDeliveryPayments
      site={site}
      paymentMethods={paymentMethods}
      deliveryMethods={deliveryMethods}
      translate={translate}
    />
  )
}
